import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';

@Component({
  selector: 'app-association-invitation',
  templateUrl: './association-invitation.component.html',
  styleUrls: ['./association-invitation.component.css']
})
export class AssociationInvitationComponent implements OnInit {

  currentUserModel: CurrentUserModel;

  constructor(private dialogRef: MatDialogRef<AssociationInvitationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService) { }

  ngOnInit() {
    this.authService.getLoginInfo()
      .subscribe((res: CurrentUserModel) => {
        this.currentUserModel = res;
      },
        (error: any) => {
          console.info(error);
        });
  }

  acceptInvitation(): void{
    if(this.currentUserModel.isAU){
      window.open("https://admin.microsoft.com/Adminportal/Home?invType=ResellerRelationship&partnerId=87dd1e14-7503-4c96-b552-2b4adc3f3bcc&msppId=0#/partners/invitation", "_blank")
    }else{
      window.open("https://admin.microsoft.com/Adminportal/Home?invType=ResellerRelationship&partnerId=e0c7ca5e-6721-482f-bfd9-540292303b98&msppId=0#/partners/invitation", "_blank")
    }
  }

  closeAgreementPopup(): void {
    this.dialogRef.close();
  }
}
